import { Component, Show } from "solid-js"
import { Img } from "../universal/image";
import { CollectionResult } from "../../types";

type Props = {
    artworkId: string;
    item: CollectionResult;
    addToAlbum: (item: CollectionResult) => Promise<void>;
    removeFromAlbum: (item: CollectionResult) => Promise<void>;
}

export const RenderCollection: Component<Props> = (props) => {
    const item = props.item;
    return (
        <>
            <div class="collection-item">
                <div class="row">
                    <div class="col-md-3">
                        <Show when={item.PrimaryImage}>
                            <Img class="img-circle" src={item.PrimaryImage.URL} mode="crop" height={60} width={60} style="object-fit: cover;" />
                        </Show>
                        <Show when={!item.PrimaryImage}>
                            <div style="width: 60px; height: 60px; background-color: #666; border-radius: 50%;"></div>
                        </Show>
                    </div>
                    <div class="col-md-9">
                        <h1>{item.Name}</h1>
                    </div>
                </div>
                <div class="action-icons">
                    <Show when={!item.IsArtworkInCollection}>
                        <button class="btn btn-success" onClick={() => props.addToAlbum(item) } style="margin-right: 10px;">
                            <span class="fa fa-check-circle-o">&nbsp;Add to</span>
                        </button>
                        {/* <button class="btn btn-default" style="margin-right: 10px;">
                            <span class="fa fa-file-text-o">&nbsp;Edit note</span>
                        </button> */}
                    </Show>
                    <Show when={item.IsArtworkInCollection}>
                        <button class="btn btn-danger" onClick={() => props.removeFromAlbum(item) } style="margin-right: 10px;">
                            <span class="fa fa-trash-o">&nbsp;Remove from</span>
                        </button>
                    </Show>
                    <span>
                        <Show when={item.IsPrivate}>
                            <span class="fa fa-lock">&nbsp;Private</span>
                        </Show>
                        <Show when={!item.IsPrivate}>
                            <span class="fa fa-unlock">&nbsp;Public</span>
                        </Show>
                    </span>
                </div>
            </div>
        </>
    )
}